export default {
  app: {
    name: 'Atlas Mobile',
    home: 'Home',
    calls: 'Calls',
    location: 'Location',
    inbox: 'Inbox',
    webmail: 'Webmail',
    webmail_inbox: 'Webmail Inbox',
    webmail_sent: 'Webmail Sent Items',
    refresh: 'Refresh App',
    copyright: 'Trios Group',
    loginForm: 'Login Form',
    login: 'Login',
    logout: 'Logout',
    cancel: 'Cancel',
    close: 'Close',
    select: 'Select',
    save: 'Save',
    invalidCredentials: 'Invalid credentials',
    back: 'Back',
    callReceived: 'Call Received',
    callResponse: 'Call Response',
    visitAllocated: 'Visit Allocated',
    createdAt: 'Created',
    updatedAt: 'Last updated',
    yes: 'Yes',
    no: 'No',
    ok: 'OK',
    welcome: 'Welcome',
    forgotPassword: 'Forgot your password?',
    username: 'Username',
    resetPassword: 'Reset Password',
    required: 'Required',
    help: 'Help'
  },
  calls: {
    availableCalls: 'Available Calls',
    refreshCalls: 'Refresh List',
    activeCall: 'Active Call',
    scheduledDate: 'Scheduled Date',
    callRef: 'Call Ref',
    eventId: 'Event ID',
    postcode: 'Postcode',
    callDetail: 'Call Detail',
    accept: 'Accept',
    travel: 'Travel',
    arrived: 'Arrived',
    details: 'Details',
    complete: 'Complete',
    arrivalComplete: 'Arrival Process',
    photos: 'Photos',
    powra: 'Powra',
    media: 'Media',
    reset: 'Reset',
    scans: 'Scans',
    scan: 'Scan',
    save: 'Save',
    documents: 'Scans & Docs',
    document: 'Document',
    attachments: 'Attachments',
    attachment: 'Attachment',
    noAssignments: 'You have no calls assigned at the moment.',
    noActiveCall: 'No Active Call',
    resetCallHeader: 'Reset this Call?',
    resetCallBody: 'Are you sure you want to reset this call?',
    resetCallConfirm: 'Reset Call',
    completeCall: 'Complete Call',
    visitStatus: 'Visit Status',
    pickPhrase: 'Pick a Phrase...<br><em>(Swipe to choose)</em>',
    travelStartTime: 'Travel Start Time',
    onSiteTime: 'On Site Time',
    offSiteTime: 'Off Site Time',
    travelEndTime: 'Travel End Time',
    workCarriedOut: 'Work Carried Out',
    clientName: 'Client Name',
    clientPosition: 'Client Position',
    travelingHome: 'I am travelling home after this job.',
    sendToOffice: 'Send To Office',
    travelEnd: 'Travel End',
    completeCallHeader: 'Complete this Visit?',
    completeCallBody:
      'Are you sure you want to complete this visit? All data will be sent to the office and data removed from the device.',
    completeCallConfirm: 'Complete Visit',
    callAccepted: 'Call Accepted',
    callNotAccepted: 'Error: Call Not Accepted',
    callTravel: 'Travel Started',
    callNotTravel: 'Error: Travel Not Started',
    callArrived: 'Arrival Onsite Recorded. Travel Ended.',
    callNotArrived: 'Error: Call not arrived',
    callReset: 'Call reset to Available status.',
    callNotReseted: 'Error: Call Not Reset',
    callCompleted: 'Call Completed.',
    travelToHomeStarted: 'Started travelling home.',
    callNotCompleted: 'Error: Call Not Completed',
    status: 'Status',
    callInfo: 'Call Info',
    callTimes: 'Timestamps',
    callHistory: 'History',
    scheduledAt: 'Scheduled for',
    estimatedDuration: 'Estimated duration',
    acceptCall: 'Accept Call',
    startTravel: 'Start Travel',
    markArrival: 'Mark Arrival',
    resetCall: 'Reset this Call',
    takePhoto: 'Take Photo',
    recordVideo: 'Record Video',
    takePicture: 'Take a Picture',
    photoTaken: 'Photo taken and saved',
    stopRecord: 'Stop Recording',
    videoRecorded: 'Video recorded and saved',
    mediaUpdated: 'Media item updated',
    mediaDeleted: 'Media item deleted',
    scanAttached: 'The scan was attached',
    scanDeleted: 'The scan was deleted',
    location: 'Location',
    directions: 'Directions',
    inbox: 'Inbox',
    inboxIsEmpty: 'Inbox is empty.',
    signature: 'Signature',
    signatureSaved: 'Signature Saved',
    signatureEmpty: 'Signature was empty, please sign and try again',
    proximityWarningHeader: 'Proximity Warning',
    proximityWarningBody:
      'The application is reporting that you are {0} from the site, are you sure you want to continue?',
    proximityConfirm: 'Accept Warning',
    contractNotes: 'Contract Notes',
    confirmContractNotes: 'I confirm I have read the contract note',
    signInMethod: 'Sign-in Method',
    noSignInMethod:
      'Contract does not specify instructions for engineer sign-in',
    confirmSignInMethod: 'I confirm I have signed in',
    workAssessment: 'Work Assessment',
    proceedToTheNextSection: 'Next >>',
    back: '<< Back',
    permissionToWork: 'Permission to Work',
    preWorkAnalysis: 'Pre-Work Requirements',
    abortVisit: 'Abort this Visit',
    abortVisitConfirmation: 'Abort Visit Confirmation',
    abortVisitConfirmationText: 'Are you sure you want to abort this visit?',
    yesAbortVisit: 'Yes, Abort this Visit',
    orderNumber: 'Order Number',
    callType: 'Call Type',
    callProblem: 'Call Problem',
    telephone: 'Telephone',
    contractNote: 'Contract Note',
    scheduledNote: 'Visit Note',
    companyAlias: 'Company Alias',
    confirmTravelEndNotEmpty: 'You must confirm your travel end time',
    travelStartMustBeLessThanOnSite:
      'Travel start time must be less than on site time.',
    onSiteMustBeLessThanOffSite:
      'On site time must be less than off site time.',
    offSiteMustBeLessThanTravelEnd:
      'Off site time must be less than travel end time.',
    mustTakeEndPhoto: 'You must take an end photo.',
    noDocumentsAttached: 'No documents attached',
    checkTimeInputs: 'Please check selected times',
    checkRequiredFields: 'Check required fields',
    someOfTheRequiredFieldsAreEmpty:
      'Please re-check your inputs. Some of the required fields are empty.',
    cancelTravelHome: 'Cancel Travel to Home',
    cancelTravelHomeConfirmation: 'Cancel Travel To Home',
    cancelTravelHomeConfirmationText:
      'Are you sure you want to cancel travel to home?',
    yesCancelTravelHome: 'Yes',
    editPowraHeader: 'Edit POWRA',
    editPowraBody: 'Editing the POWRA will create a new version.',
    editPowraConfirm: 'Confirm',
    worksheet: 'Worksheet'
  },
  workAssessment: {
    isTheSiteOccupied: 'Is the site occupied?',
    haveYouCompletedPowra: 'Have you completed the POWRA?',
    haveYouCheckedSiteAsbestosRegister:
      'Have you checked the site asbestos register?',
    haveYouCheckedAbestosWithResponsiblePerson:
      'Have you checked with the responsible person?',
    chanceOfDisturbingAsbestos: 'Is there a chance of disturbing asbestos?',
    isLonePolicyApplicable: 'Is the lone working policy applicable?',
    escalationProcess: 'Escalation process',
    contactYourController: 'Please contact your controller.'
  },
  permissionToWork: {
    clientName: 'Client Name',
    clientPosition: 'Client Position',
    checkSignature: 'Client signature required',
    addSignature:
      'A client representative must provide a signature before work may begin.'
  },
  preWorkAnalysis: {
    beginWorkOnJob: 'Begin work on job',
    estimatedTimeToCompleteVisit:
      'Enter the estimated time to complete the visit (HH:MM)',
    estimatedCostOfMaterials:
      'Enter the estimated cost of materials to complete the visit',
    arrivalConfirmation: 'Start Work Confirmation',
    startedWorkAt: 'Started work at',
    uploadTakePhoto: 'Upload/Take Photo',
    selected: 'Selected',
    photosSelected: 'photos selected',
    atLeastOnePhoto: 'Please select or take at least 1 photo'
  },
  powra: {
    pointOfWorkRiskAssessment: 'Point of work risk assessment',
    siteAndTaskDetails: 'Site and task details',
    jobNo: 'Job No:',
    client: 'Client:',
    siteAddress: 'Site address:',
    taskDetails: 'Task Details:',
    meansOfAccessToWorkArea:
      'Means of access to work area (If working at height, select the safest method)',
    mobileScaffoldTower: 'Mobile scaffold tower',
    MEWP: 'MEWP',
    trestlesStaging: 'Trestles & staging',
    podiumSteps: 'Podium steps',
    stepLadder: 'Step ladder',
    extensionLadder: 'Extension ladder',
    suspendedAccess: 'Suspended Access',
    other: 'Other:',
    hazardsRisks: 'Hazards/Risks (tick box if hazard identified)',
    h1: 'Risk of falling from or through roofs',
    h2: 'Access to equipment poor',
    h3: 'Restricted space',
    h4: 'Slips, trips or falls',
    h5: 'Falling objects',
    h6: 'Hazardous substances',
    h7: 'Do electrical supplies appear to be unsafe',
    h8: 'Not possible to electrically isolate',
    h9: 'Are there exposed moving parts',
    h10: 'Is there a risk of fire',
    h11: 'Will there be any hot work',
    h12: 'Will the working environment pose a safety risk',
    h13: 'Vulnerable working environment',
    h14: 'Is ear protection required',
    h15: 'Manual handling risk identified',
    h16: 'Is there a risk of contact with hot surfaces',
    h17: 'Inadequate lightning',
    h18: 'Is there asbestos that is likely to be disturbed',
    h19: 'Is there a potential risk of injury to others',
    h20: 'Is there risk of exposure to sharps (needles)',
    h21: 'Will there be any working at height',
    h22: 'Will there be any lone working',
    h23: 'Will task involve work with pressure systems',
    h24: 'Is there a risk of dust particles causing eye injury',
    h25: 'Will there be work in a confined space',
    h26: 'Special needs location',
    h27: 'Traffic management',
    h28: 'Pedestrian management',
    hazardRisk: 'Hazard/Risk',
    anyOtherHazardsPresent: 'Any other hazards present',
    addOtherHazard: 'Add Other Hazard',
    controlMeasuresSafetyPrecautions:
      'Control measures/safety precautions & PPE (tick box if control measure used)',
    controlMeasuresPrecautions: 'Control measures/precautions',
    c1: 'General permit to access',
    c2: 'Electrical permit to work',
    c3: 'Hot work permit',
    c4: 'Confined spaces permit',
    c5: 'Lifting permit',
    c6: 'Check asbestos register',
    c7: 'Method statements',
    c8: 'Risk assessments',
    c9: 'COSHH assessments',
    c10: 'Lone working procedure followed',
    c11: 'Safety harness used by trained personnel',
    c12: 'Fire suppression system on manual',
    c13: 'Module 2 access at height',
    c14: 'Module 5 manual handling',
    c15: 'Mobile scaffold tower training completed',
    c16: 'Respiratory protective equipment',
    c17: 'Safety helmet',
    c18: 'Eye protection',
    c19: 'Ear protection',
    c20: 'Protective gloves',
    otherControlMeasuresSafetyPrecautionsTaken:
      'Other control measures/safety precautions taken:',
    addOtherControl: 'Add Other Control Measure/Safety Precaution',
    adequateControlsToHazards:
      'Are the control measures/safety precautions in section E adequate to control the hazards in section C & D',
    listAdditionalControlMeasures:
      'If No, list the additional control measures put in place:',
    sectionGHeadline:
      'Enter the hazards identified in sections C & D and the corresponding control measures from sections E & F.',
    hazard: 'Hazard',
    controlMeasure: 'Control Measure',
    comments: 'Comments',
    carriedOutBy: 'Point of work risk assessment carried out by',
    name: 'Name',
    position: 'Position',
    sign: 'Sign',
    date: 'Date',
    checkHazardInputs: 'Check hazard/risk selections',
    selectAtLeastOneHazard:
      'Select at least one hazard/risk in section C, or enter one or more text strings in section D.',
    checkSafetyPrecautions: 'Check safety precautions',
    selectAtLeastOneControlMeasure:
      'Select at least one control measure/safety precaution in section E, or enter one or more text strings in section F.',
    other_hazards: 'Other Hazards',
    other_controls: 'Other Controls'
  },
  dataIterator: {
    rowsPerPageText: 'Items per page:',
    rowsPerPageAll: 'All',
    pageText: '{0}-{1} of {2}',
    noResultsText: 'No matching records found',
    nextPage: 'Next page',
    prevPage: 'Previous page'
  },
  dataTable: {
    rowsPerPageText: 'Rows per page:'
  },
  noDataText: 'No data available',
  saveNewPowra: {
    confirmationMessage:
      'Are you sure you have identified all the relevant hazards and have implemented suitable controls?'
  },
  dialogs: {
    delete: {
      headline: 'Delete Item',
      text: 'Are you sure you want to delete selected item?',
      agree: 'Delete',
      disagree: 'Cancel Deletion'
    }
  },
  forms: {
    index_title: 'Available Forms'
  },
  carousel: {
    prev: 'Previous',
    next: 'Next'
  }
}
